module.exports = __webpack_public_path__ + "static/img/CIP_Picto_fond-blanc_HD.9713a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CIP_Picto_fond-blanc_HD.jpg
// module id = CMwE
// module chunks = 8